import { Injectable } from '@angular/core';
import { select } from '@ngneat/elf';
import { comitteeStateStore, committeeInitialState, CommitteeStateProps } from './committee-state.store';
import { BaseStoreRepository } from '../base-store.repository';

@Injectable({
  providedIn: 'root',
})
export class CommitteeRepository extends BaseStoreRepository<CommitteeStateProps> {
  constructor() {
    super(comitteeStateStore.pipe(select(state => state)), comitteeStateStore, committeeInitialState);
  }
}
